// CommentsExtension.ts
import { Extension } from "@tiptap/core";
import type * as Y from "yjs";
import { createCommentPlugin } from "./CommentHighlightPlugin"; // the Plugin<CommentState> we wrote

export const CommentsExtension = Extension.create<{
  ydoc: Y.Doc | null;
}>({
  name: "comments",

  addOptions() {
    return { ydoc: null };
  },

  addProseMirrorPlugins() {
    const ydoc = this.options.ydoc;
    if (!ydoc) return [];
    return [createCommentPlugin(ydoc)];
  }
});
